export default __webpack_public_path__ + "static/media/molecule_science.3014f1b9.png";